import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const AttentionDashboardPage = ({ childRoutes }): React.ReactElement => {
	return (
		<div>
			<Route
				path="/buyer/dashboards"
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: '/buyer/dashboards/overview',
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

export default AttentionDashboardPage;
